const modelClasses: any[] = [
    {
        title: "舌图疾病筛查模型项目",
        img: "/model/舌图疾病筛查.png",
        introduction: "通过舌图筛查当前患者患有某种疾病概率",
        type: "舌图疾病筛查模型项目"
    },
    {
        title: "舌图辅助辨证模型项目",
        img: "/model/舌图辅助辨证.png",
        introduction: "通过舌图识别中医证型",
        type: "舌图辅助辨证模型项目"
    },
    {
        title: "齿痕分类模型项目",
        img: "/model/齿痕分类.png",
        introduction: "识别出一张舌图中齿痕的有无",
        type: "处方齿痕分类模型项目推荐模型"
    },
    {
        title: "舌苔厚薄分类模型项目",
        img: "/model/舌苔厚薄分类.png",
        introduction: "识别出一张舌图中舌苔的厚薄",
        type: "舌苔厚薄分类模型项目"
    },
    {
        title: "疾病辅助辨证模型项目",
        img: "/model/疾病辅助辨证.png",
        introduction: "通过望闻问切收集到的病人四诊信息，识别某个疾病的中医证型",
        type: "疾病辅助辨证模型项目"
    },
    {
        title: "疾病处方推荐模型项目",
        img: "/model/疾病处方推荐.png",
        introduction: "基于症状、中医诊断和证型，识别某个疾病的中医处方",
        type: "疾病处方推荐模型项目"
    },
    {
        title: "体质辨识模型项目",
        img: "/model/体质辨识.png",
        introduction: "通过望闻问切收集到的中医四诊信息，识别中医体质",
        type: "体质辨识模型项目"
    },
    {
        title: "症状提示模型项目",
        img: "/model/症状提示.png",
        introduction: "通过症状，识别相对应的其它症状特征",
        type: "症状提示模型项目"
    },
];

export default modelClasses;
